$(".js-video-widget").click(videoCtaText);
$(".js-vert-vid__item-link").click(videoCtaText);

function videoCtaText() {
    var $thisVideo = $(this);
    var ctaText = $thisVideo.attr('data-cta-Text');
    var ctaLink = $thisVideo.attr('data-cta-link');
    var ctaTarget = $thisVideo.attr('data-cta-target');
    var videoSidebarHeader = $thisVideo.attr('data-video-sidebar-header');
    $(".js-drawer__nav-cta-btn").html(ctaText);
    $(".js-drawer__nav-cta-btn").attr("href", ctaLink);
    $(".js-drawer__nav-cta-btn").attr("target", ctaTarget);
    if (ctaLink == "" || ctaLink == null) {
        $(".js-drawer__nav-cta-btn").css('display', 'none');
        $(".js-drawer__nav-cta-btn").attr('aria-hidden', 'true');
    }
    else {
        $(".js-drawer__nav-cta-btn").css('display', 'inline-block');
        $(".js-drawer__nav-cta-btn").removeAttr('aria-hidden');
    }
    if (videoSidebarHeader == "" || videoSidebarHeader == null) {
        $(".js-drawer__thumb-nav-heading").attr('aria-hidden', 'true');
    } else {
        $(".js-drawer__thumb-nav-heading").removeAttr('aria-hidden');
        $(".js-drawer__thumb-nav-heading").html(videoSidebarHeader);
    }
}